import {useBaseConfig} from '@/biz/baseConfig'

export const useIcp = () => {
    const swr = useBaseConfig()

    if (swr.data) {
        const {icp, icpLink} = swr.data
        let number = ''

        try {
            const icpMap = JSON.parse(icp)
            number = icpMap[location.hostname] ?? ''
        }
        catch (_) {
            number = icp
        }

        const data = {number, url: icpLink}
        return {...swr, data}
    }
    else {
        return swr
    }
}
